import { FC } from 'react'

import { SettingsPageLayout } from '../components/SettingsPageLayout'
import {
  Button,
  EmptyState,
  GreyWhite,
  IconBell,
  IconPlus,
  IndigoIndigo60,
  Link,
  SettingsGroup
} from '@sequencehq/core-components'

import { useQuery } from '@sequencehq/api'

import { SETTINGS_STALE_TIME } from '../settings.constants'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { NotificationPolicyCard } from 'SettingsV2/components/notifications/NotificationPolicyCard'

export const NotificationsSettingsPage: FC = () => {
  const { data, isError, isLoading } = useQuery(
    dashboard20240730Client.getAllNotificationPolicies,
    undefined,
    {
      staleTime: SETTINGS_STALE_TIME
    }
  )

  const emailPolicies = data?.items.filter(policy => policy.channel === 'EMAIL')

  return (
    <SettingsPageLayout
      header="Notifications"
      subheader="Configure notifications sent by Sequence"
      isError={isError}
      actions={
        <Button
          as={Link.Unstyled}
          to="/settings/notifications/new"
          variant="primary"
          data-testid="settings.notifications.new"
          leadingIcon={<IconPlus color={GreyWhite} />}
        >
          New notification
        </Button>
      }
    >
      <SettingsGroup isLoading={isLoading}>
        {emailPolicies?.map(policy => (
          <NotificationPolicyCard key={policy.id} policy={policy} />
        ))}

        {!emailPolicies?.length && (
          <EmptyState
            title="No policies setup"
            icon={IconBell}
            iconSize="sm"
            body={
              <>
                Create a new billing schedule for a customer and put invoicing
                on autopilot,{' '}
                <Link
                  _hover={{ textDecoration: 'none' }}
                  to="https://docs.sequencehq.com/reference/latest/notifications/create-notification-policy"
                  color={IndigoIndigo60}
                  target="_blank"
                >
                  learn more
                </Link>
                .
              </>
            }
          />
        )}
      </SettingsGroup>
    </SettingsPageLayout>
  )
}
